import { Injectable } from '@angular/core';
import { RootContextBase } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';
import { CacheStorage } from './../cache-storage/cache-storage.service';
import { QueryBus } from './../query/query-bus.service';

export { RootContextBase };

@Injectable({ providedIn: 'root'})
@Wrapper(RootContextBase)
export class RootContext {
    public constructor(
        private storage: CacheStorage,
        private queryBus: QueryBus
    ) { }
}
